import React, { useState } from 'react';
import { Box, Button, Container, Grid, TextField, Typography } from '@mui/material';
import emailjs from '@emailjs/browser';

const ContactForm = () => {

  const [payload, setPayload] = useState({
    name: '',
    email: '',
    message: ''
  });

  const onChangeHandler = (name, value) => {
    console.log(name, value)
    setPayload((prev)=>({
      ...prev,
      [name]: value
    }))
  }

  const onsubmit = (e) => {

    const templateParams = {
      name: payload.name,
      email: payload.email,
      message: payload.message,
    };

    emailjs.send(
      "service_5dw5aig",
      "template_yt5wcc9",    // from EmailJS
      templateParams,
      '4FtgLO6mDsUXl7wTR'         // from EmailJS
    ).then(
      (result) => {
        console.log('Email sent:', result.text);
        alert("Email sent successfully!");
      },
      (error) => {
        console.log('Error:', error);
        alert("Failed to send email.");
      }
    );
  }

  return (
    <Box id="contact" className="contact-form">
      <Container>
        <Typography variant="h4" className="section-title" data-aos="fade-up">
          Contact Us
        </Typography>
        <form data-aos="fade-up" data-aos-delay="200">
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <TextField fullWidth onChange={(evt) => {onChangeHandler('name', evt.target.value)}} label="Your Name" variant="outlined" className="contact-input" />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField fullWidth value={payload.email} onChange={(evt) => {onChangeHandler('email', evt.target.value)}} label="Your Email" variant="outlined" className="contact-input" />
            </Grid>
            <Grid item xs={12}>
              <TextField fullWidth value={payload.message} onChange={(evt) => {onChangeHandler('message', evt.target.value)}} label="Your Message" variant="outlined" multiline rows={4} className="contact-input" />
            </Grid>
            <Grid item xs={12} className="text-center">
              <Button variant="contained" color="secondary" type="button" onClick={()=> {
                  onsubmit()
              }}>
                Send Message
              </Button>
            </Grid>
          </Grid>
        </form>
      </Container>
    </Box>
  );
};

export default ContactForm;
